import splashTypes from "./splash.types"

export const setSplashData = data => {
    return {
        type: splashTypes.SPLASH,
        payload: data
    }
}
